import React, { useState } from "react";
import dayjs from "dayjs";
import { Phone, Video, PhoneMissed, ArrowUpRight, ArrowDownLeft, Trash2 } from "lucide-react";
import { useI18n } from "@/context/I18nContext";
import { getInitials, avatarColor } from "@/lib/avatar";

export function logCall(entry) {
  try {
    const list = JSON.parse(localStorage.getItem("rc_calls") || "[]");
    list.unshift({ ...entry, at: new Date().toISOString() });
    localStorage.setItem("rc_calls", JSON.stringify(list.slice(0, 100)));
  } catch (e) {}
}

export default function CallsPage({ onCall }) {
  const { t } = useI18n();
  const [filter, setFilter] = useState("all");
  const [calls, setCalls] = useState(() => { try { return JSON.parse(localStorage.getItem("rc_calls") || "[]"); } catch (e) { return []; } });

  const clear = () => { localStorage.removeItem("rc_calls"); setCalls([]); };
  const shown = filter === "missed" ? calls.filter((c) => c.missed) : calls;

  return (
    <div className="h-full overflow-y-auto no-scrollbar bg-[var(--rc-bg)]" data-testid="calls-page">
      <div className="rc-safe-top px-5 pt-6">
        <div className="flex items-center justify-between mb-4">
          <h1 className="font-heading text-5xl">{t("calls")}</h1>
          <button onClick={clear} data-testid="calls-clear-btn" className="h-11 w-11 grid place-items-center rounded-full border border-[var(--rc-gold)]/40 text-[var(--rc-gold)]"><Trash2 size={18} /></button>
        </div>
        <div className="flex rounded-full bg-[var(--rc-surface)] p-1 mb-5">
          {[["all", t("all")], ["missed", t("missed")]].map(([k, l]) => (
            <button key={k} onClick={() => setFilter(k)} data-testid={`calls-filter-${k}`}
              className={`flex-1 rounded-full py-2 text-sm font-medium transition-colors ${filter === k ? "bg-[var(--rc-gold)]/20 text-[var(--rc-gold)]" : "text-[var(--rc-muted)]"}`}>{l}</button>
          ))}
        </div>

        {shown.length === 0 ? (
          <div className="text-center py-24 text-[var(--rc-muted)]">
            <Phone size={40} className="mx-auto mb-3 text-[var(--rc-gold)]" />
            <p>{t("no_calls")}</p>
          </div>
        ) : (
          <div className="space-y-1">
            {shown.map((c, i) => (
              <div key={i} className="flex items-center gap-3 py-3 border-b border-[var(--rc-border)]" data-testid={`call-item-${i}`}>
                <div className="h-12 w-12 rounded-full grid place-items-center text-[var(--rc-gold)] font-semibold border-2 border-[var(--rc-gold)]" style={{ backgroundColor: avatarColor(c.name) }}>{getInitials(c.name)}</div>
                <div className="min-w-0 flex-1">
                  <div className={`font-medium truncate ${c.missed ? "text-red-400" : ""}`}>{c.name}</div>
                  <div className="text-xs text-[var(--rc-muted)] flex items-center gap-1">
                    {c.missed ? <PhoneMissed size={12} className="text-red-400" /> : c.outgoing ? <ArrowUpRight size={12} className="text-[var(--rc-gold)]" /> : <ArrowDownLeft size={12} className="text-emerald-400" />}
                    {dayjs(c.at).format("DD MMM · HH:mm")}
                  </div>
                </div>
                <button onClick={() => onCall && onCall(c)} data-testid={`callback-btn-${i}`} className="h-11 w-11 grid place-items-center rounded-full border border-[var(--rc-gold)]/40 text-[var(--rc-gold)]">
                  {c.video ? <Video size={18} /> : <Phone size={18} />}
                </button>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
